import { Injectable } from '@angular/core';
import { NavigationCancel, NavigationError, NavigationStart, Router } from '@angular/router';
import { WindowRef } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { BehaviorSubject, timer } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

const PRODUCT_URL_PATTERN = /\/product\//;
const SAFETY_TIMEOUT_MS = 8000;

@Injectable({
  providedIn: 'root',
})
export class KnBrPdpLoadingService {
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  readonly loading$ = this.loadingSubject.asObservable();

  constructor(router: Router, currentProductService: CurrentProductService, winRef: WindowRef) {
    // On a hard page refresh, Angular's Router hasn't parsed the browser's current
    // URL into its own state yet by the time this service is constructed, so
    // `router.url` can't be trusted here. Read the real location directly instead.
    const initialPath = winRef.nativeWindow?.location?.pathname ?? '';
    if (PRODUCT_URL_PATTERN.test(initialPath)) {
      this.loadingSubject.next(true);
    }

    router.events.subscribe((event) => {
      if (event instanceof NavigationStart && PRODUCT_URL_PATTERN.test(event.url)) {
        this.loadingSubject.next(true);
      } else if (event instanceof NavigationCancel || event instanceof NavigationError) {
        this.loadingSubject.next(false);
      }
    });

    currentProductService.getProduct().subscribe((product) => {
      if (product) {
        this.loadingSubject.next(false);
      }
    });

    this.loadingSubject
      .pipe(
        filter((isLoading) => isLoading),
        switchMap(() => timer(SAFETY_TIMEOUT_MS))
      )
      .subscribe(() => this.loadingSubject.next(false));
  }
}
